import Cookies from "js-cookie";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";

import { AdminContext } from "context/AdminContext";
import { SidebarContext } from "context/SidebarContext";
import AdminServices from "services/AdminServices";
import { notifyError, notifySuccess } from "utils/toast";

const useStaffSubmit = (id) => {
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(0);
  const [, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedAllCityinState, setSelectedAllCityinState] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const location = useLocation();
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);
      const stateIds = selectedState.map((state) => {
        if (typeof state === 'string') {
          return parseInt(state, 10); 
        }
        if (typeof state === 'object' && state.value) {
          return parseInt(state.value, 10);
        }
        return null;
      }).filter(Boolean); 

      const staffData = {
        name: data.name,
        email: data.email,
        password: data.password_update,
        mobile: data.mobile,
        status: 'Active',
        id_profile: data.id_profile,
        state: stateIds
      };

      if (id) {
        const res = await AdminServices.updateStaff(id, staffData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await AdminServices.addStaff( staffData );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      const errorMessage =
      err?.response?.data?.message?.message || err?.response?.data?.message || err?.message || "An unknown error occurred";
      notifyError(errorMessage); 
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getStaffData = async () => {
    try {
      const res = await AdminServices.getStaffById(id, {
        email: adminInfo.email,
      });
      if (res) {
        setValue("name", res.name);
        setValue("lastname",res.lastname);
        setValue("email", res.email);
        setValue("password_update",res.password_update);
        setValue("mobile", res.mobile);
        setValue("id_profile", res.id_profile);
        setStatus(res.status === 'Active'? true : false);
          setTimeout(() => {
            setValue("all_city_in_state", res.all_city_in_state);
            setSelectedCities(res.city);
            setValue("city", res.city);
          }, 500);
  
        setValue("state", res.state);
        setSelectedState(res.state);
        setSelectedCities(res.city);
        setSelectedAllCityinState(res.all_city_in_state);
        setImageUrl(process.env.REACT_APP_API_IMAGE_URL+res.emp_image);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setSelectedAllCityinState([]);
      setSelectedCities([]);
      setSelectedState([]);
      setValue("firstname");
      setValue("lastname");
      setValue("email");
      setValue("password_update");
      setValue("mobile");
      setValue("id_profile");
      setValue("state");
      setValue("all_city_in_state");
      setValue("city");
      clearErrors();
      return;
    }
      
    if (id) {
      getStaffData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, adminInfo.email, clearErrors]);

  useEffect(() => {
    if (location.pathname === "/edit-profile" && Cookies.get("adminInfo")) {
      getStaffData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, setValue]);

  return {
    trigger,
    register,
    handleSubmit,
    selectedCities,
    setSelectedCities,
    onSubmit,
    status,
    setStatus,
    errors,
    loading,
    setLoading,
    setSelectedState,
    selectedState,
    isSubmitting,
    selectedAllCityinState, setSelectedAllCityinState
  };
};

export default useStaffSubmit;
